// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Autocomplete
} from '@mui/material'
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider'
import Swal from 'sweetalert2'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token
    const { showToast, hideToast } = useToast();

    const tabDetail = localStorage.getItem('tab-detail')!

    // ** State
    const [value, setValue] = useState<string>(tabDetail)

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [valAkun, setValAkun] = useState<any>(null)
    const [listAkun, setListAkun] = useState<any[]>([])

    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        getData(value)
        getAkun()
    }, [])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        setListData([])

        let url = ''
        if (mode == 0) {
            url = apiUrl.apiUrl + '/acc/mutasi-kas/list-masuk'
        } else {
            url = apiUrl.apiUrl + '/acc/mutasi-kas/list-keluar'
        }

        axios
            .get(url, {
                params: { tgl_awal: tglAwal, tgl_akhir: tglAkhir, akun: valAkun?.id, user: user.sysrole_id },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getAkun = () => {
        setListData([])
        let url = apiUrl.apiUrl + '/acc/mutasi-kas/get-akun'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    if (Array.isArray(data)) {
                        data.forEach((item: any) => {
                            if (item && item.id != null && item.nama != null) item.nama = `${item.id} | ${item.nama} | Saldo: ${item.saldo ?? 0}`
                        })
                    }
                    setListAkun(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const ActionButtons = ({ row, onNavigate, onDelete }: {
        row: any;
        onNavigate: (id: string) => void;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                // onClick: () => onNavigate(row.id),
                onClick: () => window.open('/acc/mutasi-kas-bank/detail/' + row.id, '_blank'),
                disabled: false
            },
            {
                title: "Cetak",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/acc/mutasi-kas-bank/pdf/' + row.id, '_blank'),
                disabled: false
            },
            {
                title: "Cetak A6",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/acc/mutasi-kas-bank/pdf-a6/' + row.id, '_blank'),
                disabled: false
            },
            {
                title: "Batalkan",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row),
                disabled: row.doc_type != null
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}
                            disabled={action.disabled}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin batalkan transaksi ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Batalkan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/acc/mutasi-kas/hapus-dokumen/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData(value)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 180,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onNavigate={(id) => navigate('/acc/mutasi-kas-bank/detail/' + id)}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    const handleChangeAkun = (event: SyntheticEvent, newValue: any | null) => {
        setValAkun(newValue)
    }

    const handleChangeTab = (event: SyntheticEvent, newValue: string) => {
        setValue(newValue)
        getData(newValue)
        window.localStorage.setItem('tab-detail', newValue)
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='MUTASI KAS BANK' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Autocomplete
                                    value={valAkun}
                                    options={listAkun}
                                    id='akun'
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onChange={handleChangeAkun}
                                    renderOption={(props, option) => {
                                        return (
                                            <li {...props} key={option.id}>
                                                {option.nama}
                                            </li>
                                        )
                                    }}
                                    getOptionLabel={option => option.nama}
                                    renderInput={params => (
                                        <FormControl fullWidth>
                                            <TextField
                                                {...params}
                                                label='Akun'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </FormControl>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={getData}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={value}>
                        <TabList
                            scrollButtons
                            variant='fullWidth'
                            onChange={handleChangeTab}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='KAS BANK MASUK' icon={<Icon icon='mdi:database-arrow-left' />} />
                            <Tab value='1' label='KAS BANK KELUAR' icon={<Icon icon='mdi:database-arrow-right' />} />
                        </TabList>
                        <TabPanel value='0'>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    startIcon={<Icon icon='mdi:plus' />}
                                    onClick={() => navigate('/acc/mutasi-kas-bank/add?is_masuk=1')}
                                >
                                    Buat Mutasi
                                </Button>
                            </Box>
                            <MsiDatagrid array={listData} actions={actionData} hiddenColumns={['sysmatauang_id', 'sysdoctag_id', 'nomor', 'doc_id', 'doc_type']} convertNumeric={['Total']} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    startIcon={<Icon icon='mdi:plus' />}
                                    onClick={() => navigate('/acc/mutasi-kas-bank/add?is_masuk=0')}
                                >
                                    Buat Mutasi
                                </Button>
                            </Box>
                            <MsiDatagrid array={listData} actions={actionData} hiddenColumns={['sysmatauang_id', 'sysdoctag_id', 'doc_id', 'doc_type']} convertNumeric={['Total']} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
        </Grid>
    )
}
